import STORAGE_NAME from '@/const/storage';
import storeRequest from './request/storeRequest';
import { serializeQueryParams } from '@/helpers/utilities';

let storeId = localStorage.getItem(STORAGE_NAME.STORE_ID);
storeRequest.setStoreId(storeId);

function getSyncCollections(params) {
  return storeRequest.get('/v2/collections', {
    params: { ...params, sync: true },
  });
}

function getSyncCollectionCount(params) {
  return storeRequest.get('/v2/collections/count', {
    params: { ...params, sync: true },
  });
}

function createSyncCollection(data) {
  return storeRequest.post('/v2/collections', {
    collection: { ...data, isSyncColl: true },
  });
}

function getSyncCollectionById(id) {
  return storeRequest.get('/v2/collections/' + id);
}

function updateSyncCollection(id, data) {
  return storeRequest.put('/v2/collections/' + id, {
    collection: { ...data, isSyncColl: true },
  });
}

function deleteSyncCollection(id) {
  return storeRequest.delete('/v2/collections/' + id);
}

function getProductFeeds(params) {
  const query = serializeQueryParams(params);
  const path = query ? `/v2/feed?${query}` : '/v2/feed';
  return storeRequest.get(path);
}

function getCountProductFeeds(params) {
  const query = serializeQueryParams(params);
  const path = query ? `/v2/feed/count?${query}` : '/v2/feed/count';
  return storeRequest.get(path);
}

function getProductFeedById(id) {
  return storeRequest.get('/v2/feed/' + id);
}

function updateProductFeed(params) {
  return storeRequest.put('/v2/feed/' + params.productFeed._id, params);
}

function createProductFeed(params) {
  return storeRequest.post('/v2/feed', params);
}

function getGoogleProductCategory() {
  return storeRequest.get('/v2/feed/google/categories');
}

function deleteProductFeed(params) {
  return storeRequest.delete('/v2/feed/' + params.id);
}

function getCatalogs(params) {
  return storeRequest.get('/v2/spy-catalogs/find_by_store', {
    // return storeRequest.get('/v2/spy-catalogs', {
    params: { ...params },
  });
}

function getCatalogCount(params) {
  return storeRequest.get('/v2/spy-catalogs/count', {
    params: { ...params },
  });
}

function getCatalogById(id) {
  return storeRequest.get('/v2/spy-catalogs/' + id);
}

function importProductsToStore(data) {
  return storeRequest.post('/v2/spy-catalogs/import/products', data);
}

function getGoogleTaxonomy() {
  return storeRequest.get('/v2/spy-catalogs/google/taxonomy');
}

export const gmcApi = {
  getSyncCollections,
  getSyncCollectionCount,
  createSyncCollection,
  getSyncCollectionById,
  updateSyncCollection,
  deleteSyncCollection,
  getProductFeeds,
  getCountProductFeeds,
  getProductFeedById,
  updateProductFeed,
  createProductFeed,
  getGoogleProductCategory,
  deleteProductFeed,
  getCatalogs,
  getCatalogCount,
  getCatalogById,
  importProductsToStore,
  getGoogleTaxonomy,
};
